import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Heading,
  HStack,
  Image,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Spinner,
  Center
} from '@chakra-ui/react'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import { PDFExport } from '@progress/kendo-react-pdf'
import moment from 'moment'
import { FC, SetStateAction, useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet'
import { AiOutlinePushpin } from 'react-icons/ai'
import { BsClockHistory } from 'react-icons/bs'
import { RiShoppingCartLine } from 'react-icons/ri'
import { useLocation } from 'react-router-dom'
import { useImmer } from 'use-immer'

import InfoCard from '@component/Layout/Card/Info'
import TableGrid from '@component/Layout/TableGrid'
import KpiRuptureGraphicExport from '@component/Modules/Kpi/Graphics/KpiRuptureGraphicExport'
import KpiSalesGraphicExport from '@component/Modules/Kpi/Graphics/KpiSalesGraphicExport'
import ActualSaleVersusBudgetedSalesChartsExport from '@component/Pages/Overview/Charts/ActualSaleVersusBudgetedSaleExport'
import RuptureChartsExport from '@component/Pages/Overview/Charts/RuptureExport'
import OverviewTableExport from '@component/Pages/Overview/TableExport'

import {
  overviewGeneralStockParserFooter,
  overviewGeneralStockParserWithFooter,
  overviewProductParser,
  overviewStockParser
} from '@helper/grid'
import { parseLogisticKpiData } from '@helper/kpi/logistic/parseLogisticKpiData'
import { parseRuptureKpiData } from '@helper/kpi/rupture/parseRuptureKpiData'
import { parseSalesKpiData } from '@helper/kpi/sales/parseSalesKpiData'
import generic from '@service/generic'

import { logisticKpiHeader } from '@base/variables/headers/kpi/logistic/logisticKpiHeader'
import { kpiRuptureHeader } from '@base/variables/headers/kpi/rupture/ruptureKpiHeaderExport'
import { kpiSalesHeader } from '@base/variables/headers/kpi/sales/kpiSalesHeaderExport'
import { kpiSalesHeaderWorld } from '@base/variables/headers/kpi/sales/kpiSalesHeaderExportWorld'
import overviewGeneralStockTableHeaders from '@base/variables/headers/overview/general-stock-table-headers'
import overviewProductTableHeaders from '@base/variables/headers/overview/product-table-headers'
import overviewStockTableHeaders from '@base/variables/headers/overview/stock-table-headers'

// import overviewStockTableHeaders from '@base/variables/headers/overview/stock-table-headers'

// //
export interface Alertas {
  alertaCompras: number
  alertaRecebimento: number
}

export interface GraficoVendas {
  vendaReal: number
  vendaOrcada: number
}

export interface EstoqueGeralPorStatu {
  status: string
  centroDistribuicao: number
  loja: number
  total: number
}

export interface ProdutoStatusEncomenda {
  posicao: number
  codigo: number
  descricao: string
  quantidade: number
  valor: number
}

export interface ProdutoStatusSlsf {
  posicao: number
  codigo: number
  descricao: string
  quantidade: number
  valor: number
}

export interface ProdutoSemVenda {
  posicao: number
  codigo: number
  descricao: string
  quantidade: number
  valor: number
}

export interface EstoqueEmCarteiraFornecedor {
  posicao: number
  codigo: number
  descricao: string
  quantidade: number
  valor: number
}
export interface GraficoAglomerado {
  margem: any[]
  vendas: any[]
}

export interface VendaIndicadorPorMundo {
  diaKPI: number
  rsCusto: number
  rsReceitaBruta: number
  rsReceitaLiquida: number
  btReceitaBruta: number
  btReceitaLiquida: number
  margemLiquida: number
  margemLiquidaPercentual: number
  rsDescontoMedio: number
  descontoPercentual: number
  diaDespesas: number
  rsMetaReceitaLiquida: number
  btMetaReceitaLiquida: number
  margemLiquidaAlvo: number
  margemLiquidaPercentualAlvo: number
  rsMetaReceitaLiquidaRealizada: number
  btMetaReceitaLiquidaRealizada: number
  margemAlvoRealizada: number
  mundoId: number
  mundoDescricao: string
}
export interface KpiVendas {
  graficoAglomeradoTipoReal: GraficoAglomerado
  vendaIndicadorPorMundo: VendaIndicadorPorMundo[]
  aglomerado: VendaIndicadorPorMundo[]
}

export interface AglomeradoCurvaA {
  totalSKUs: number
  skUsRupturaZeroDias: number
  rupturaPercentualZeroDias: number
  skUsRupturaDezDias: number
  rupturaPercentualDezDias: number
}

export interface AglomeradoCurvaB {
  totalSKUs: number
  skUsRupturaZeroDias: number
  rupturaPercentualZeroDias: number
  skUsRupturaDezDias: number
  rupturaPercentualDezDias: number
}

export interface AglomeradoCurvaC {
  totalSKUs: number
  skUsRupturaZeroDias: number
  rupturaPercentualZeroDias: number
  skUsRupturaDezDias: number
  rupturaPercentualDezDias: number
}
export interface GraficoAglomeradoCurvaA {
  zeroDias: any[]
  dezDias: any[]
}
export interface KpiRuptura {
  aglomeradoCurvaA: AglomeradoCurvaA[]
  graficoAglomeradoCurvaA: any
  aglomeradoCurvaB: AglomeradoCurvaB[]
  graficoAglomeradoCurvaB: any
  aglomeradoCurvaC: AglomeradoCurvaC[]
  graficoAglomeradoCurvaC: GraficoAglomeradoCurvaA
}
export interface MaioresDesvio {
  pedidosUltimosDozeMeses: number
  skUsMedioPorPedido: number
  proporcaoEntregaAntesPrazoFinal: number
  proporcaoEntrega: number
  proporcaoEntregaAposPrazoFinal: number
  entregaParcial: number
  entregaCompleta: number
  tempoExecucaoSistema: number
  tempoRealizado: number
  diferencaRealizadaExecucaoSistema: number
  diferencaRealizadaProporcaoTempo: number
  ano: number
  mes: number
  desvioMedio: number
  fornecedorId: number
  fornecedorDescricao: string
}

export interface MenoresDesvio {
  pedidosUltimosDozeMeses: number
  skUsMedioPorPedido: number
  proporcaoEntregaAntesPrazoFinal: number
  proporcaoEntrega: number
  proporcaoEntregaAposPrazoFinal: number
  entregaParcial: number
  entregaCompleta: number
  tempoExecucaoSistema: number
  tempoRealizado: number
  diferencaRealizadaExecucaoSistema: number
  diferencaRealizadaProporcaoTempo: number
  ano: number
  mes: number
  desvioMedio: number
  fornecedorId: number
  fornecedorDescricao: string
}
export interface KpiLogistica {
  maioresDesvios: MaioresDesvio[]
  menoresDesvios: MenoresDesvio[]
}
export interface Painel {
  followUp: number
  alertas: Alertas
  graficoRuptura: any[]
  graficoVendas: GraficoVendas
  estoqueGeralPorStatus: EstoqueGeralPorStatu[]
  produtoStatusEncomenda: ProdutoStatusEncomenda[]
  produtoStatusSLSF: ProdutoStatusSlsf[]
  produtoSemVenda: ProdutoSemVenda[]
  estoqueEmCarteiraFornecedor: EstoqueEmCarteiraFornecedor[]
}
export interface DataReport {
  painel?: Painel
  kpiVendas?: KpiVendas
  kpiRuptura?: KpiRuptura
  kpiLogistica?: KpiLogistica
}
const Export: FC = () => {
  const [data, updateData] = useImmer<DataReport>({})
  const [date, updateDate] = useImmer('')
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [form] = useImmer({
    empresas: []
  })
  const contentRef = useRef(null)
  const search = useLocation().search
  //
  const ddData = [
    { text: 'A4', value: 'size-a4' },
    { text: 'Letter', value: 'size-letter' },
    { text: 'Executive', value: 'size-executive' }
  ]

  const [layoutSelection, setLayoutSelection] = useState({
    text: 'A4',
    value: 'size-a4'
  })

  const updatePageLayout = (event: {
    target: { value: SetStateAction<{ text: string; value: string }> }
  }) => {
    setLayoutSelection(event.target.value)
  }

  const pdfExportComponent = useRef(null)

  const handleExportWithComponent = async () => {
    setTimeout(async function () {
      await pdfExportComponent.current.save(() => {
        window.close()
      })
    }, 3000)
  }

  const [selectRealOrBtleo, setSelectRealOrBtleo] = useState('1')
  const handleSetSelectRealOrBtleo = (value: string) => {
    setSelectRealOrBtleo(value)
  }

  useEffect(() => {
    onOpen()
    const id = new URLSearchParams(search).get('param')
    if (id) {
      generic
        .getReportAll(id)
        .then(({ data }) => {
          updateData(data?.relatorioGeral)
          updateDate(data?.data)

          handleExportWithComponent()
        })
        .catch(() => {
          window.close()
        })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <>
      <Helmet>
        <title>Relatório Geral - SCL</title>
      </Helmet>
      <div className="box wide hidden-on-narrow">
        <div className="box-col">
          <h4>Select a Page Size</h4>
          <DropDownList
            data={ddData}
            textField="text"
            dataItemKey="value"
            value={layoutSelection}
            onChange={updatePageLayout}
          />
        </div>
        <div className="box-col">
          <h4>Export PDF</h4>
          <Button onClick={handleExportWithComponent}>Export</Button>
        </div>
      </div>
      <Modal onClose={onClose} size={'full'} isOpen={isOpen}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody bgColor="green.500">
            <Center>
              <Flex
                pt={220}
                alignItems="center"
                justifyContent="center"
                flexDir="column"
              >
                <Center>
                  <Image src="/assets/images/logo.svg" w="124px" mr="auto" />
                </Center>

                <Heading pt={6} mb={6} size="xl" color="white" fontWeight="400">
                  Gerando relatório, aguarde até o download...
                </Heading>
                <Spinner color="yellow.400" size="xl" />
              </Flex>
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>
      <PDFExport ref={pdfExportComponent} margin="2cm">
        <div ref={contentRef}>
          <Box m={20} minWidth={1800} maxWidth={2200}>
            <HStack p={5}>
              <Image src="/assets/images/logo.svg" w="104px" />

              <Heading
                as="h5"
                pt={2}
                size="2xl"
                alignContent={'center'}
                alignItems={'center'}
              >
                Relatorio Diario {moment(date).format('DD/MM/YYYY')}{' '}
              </Heading>
            </HStack>
            <br></br>
            <br></br>
            <section className="cards-slider">
              <Box maxW="100%" px={3} pt={3}>
                <Heading
                  as="h5"
                  size="lg"
                  pb={5}
                  alignContent={'center'}
                  alignItems={'center'}
                >
                  Alertas Diarios
                </Heading>
                <Grid templateColumns="repeat(3, 1fr)" gap={6}>
                  <GridItem w="100%" h="10">
                    <Box marginRight={3} bg="gray.100">
                      <InfoCard
                        bg="gray.100"
                        title="Follow up"
                        value={
                          data?.painel?.followUp &&
                          data?.painel?.followUp.toLocaleString('pt-br', {
                            maximumFractionDigits: 0
                          })
                        }
                        icon={<AiOutlinePushpin />}
                      />
                    </Box>
                  </GridItem>
                  <GridItem w="100%" h="10">
                    <Box marginRight={3} bg="gray.100">
                      <InfoCard
                        bg="gray.100"
                        title="Alertas de compras"
                        value={
                          data?.painel?.alertas?.alertaCompras &&
                          data?.painel?.alertas?.alertaCompras.toLocaleString(
                            'pt-br',
                            {
                              maximumFractionDigits: 0
                            }
                          )
                        }
                        icon={<RiShoppingCartLine />}
                      />
                    </Box>
                  </GridItem>
                  <GridItem w="100%" h="10">
                    <Box marginRight={3} bg="gray.100">
                      <InfoCard
                        bg="gray.100"
                        title="Alertas de adiantamentos"
                        icon={<BsClockHistory />}
                        value={
                          data?.painel?.alertas?.alertaRecebimento &&
                          data?.painel?.alertas?.alertaRecebimento.toLocaleString(
                            'pt-br',
                            {
                              maximumFractionDigits: 0
                            }
                          )
                        }
                      />
                    </Box>
                  </GridItem>
                </Grid>
              </Box>
            </section>

            <Box maxW="100%" px={3} pt={20}>
              <Grid templateColumns="repeat(3, 1fr)" gap="16px" height="470px">
                {data?.painel?.graficoVendas && (
                  <>
                    <ActualSaleVersusBudgetedSalesChartsExport
                      dataActualSales={data?.painel?.graficoVendas}
                    />
                  </>
                )}
                {data?.painel?.graficoRuptura && (
                  <>
                    <Box height="100%" display={['none', 'none', 'block']}>
                      <RuptureChartsExport
                        dataRupture={data?.painel?.graficoRuptura}
                        tabState={0}
                      />
                    </Box>
                  </>
                )}{' '}
                {data?.painel?.graficoRuptura && (
                  <>
                    <Box height="100%" display={['none', 'none', 'block']}>
                      <RuptureChartsExport
                        dataRupture={data?.painel?.graficoRuptura}
                        tabState={1}
                      />
                    </Box>
                  </>
                )}
              </Grid>
            </Box>
            <br></br>
            <br></br>
            <Box
              paddingBottom={3.5}
              boxShadow="inset 0px 1px 5px 2px #dcdcdc"
            />
            {data?.kpiVendas && (
              <>
                <Box
                  p={6}
                  mx={3}
                  mb={2}
                  bg="white"
                  borderRadius="8px"
                  boxShadow="sm"
                >
                  <Flex
                    alignItems="center"
                    justifyContent="space-between"
                    pb={'21.4px'}
                    mb={6}
                  ></Flex>

                  <>
                    <Heading
                      as="h5"
                      size="lg"
                      pb={5}
                      alignContent={'center'}
                      alignItems={'center'}
                    >
                      KPI Vendas (Mes a mes/R$)
                    </Heading>
                    <KpiSalesGraphicExport
                      getChartData={null}
                      updateRealOrBtleoState={handleSetSelectRealOrBtleo}
                      realOrBtleoState={selectRealOrBtleo}
                      data={data?.kpiVendas?.graficoAglomeradoTipoReal}
                      stateOption={'2'}
                    />
                    <Box
                      paddingBottom={3.5}
                      boxShadow="inset 0px 1px 5px 2px #dcdcdc"
                    />
                    <br />
                    <br />
                    <br />
                    <Heading
                      as="h5"
                      size="lg"
                      pb={5}
                      alignContent={'center'}
                      alignItems={'center'}
                    >
                      KPI Vendas (Acumulado/R$)
                    </Heading>
                    <KpiSalesGraphicExport
                      getChartData={null}
                      updateRealOrBtleoState={handleSetSelectRealOrBtleo}
                      realOrBtleoState={selectRealOrBtleo}
                      data={data?.kpiVendas?.graficoAglomeradoTipoReal}
                      stateOption={'1'}
                    />
                    <Box
                      paddingBottom={3.5}
                      boxShadow="inset 0px 1px 5px 2px #dcdcdc"
                    />
                    <br />
                    <br />
                    <br />
                    <Heading
                      as="h5"
                      size="lg"
                      pb={5}
                      alignContent={'center'}
                      alignItems={'center'}
                    >
                      KPI Vendas (Empresa)
                    </Heading>
                    <TableGrid
                      id="alert-followUp"
                      entity="kpi-sales"
                      data={parseSalesKpiData(data?.kpiVendas?.aglomerado)}
                      query={''}
                      headers={kpiSalesHeader}
                      loading={false}
                      itsSortable={true}
                      height={
                        String(data?.kpiVendas?.aglomerado.length * 80) + 'px'
                      }
                      isPagedBack={false}
                      isPaged={false}
                    />
                    <br />
                    <br />
                    <br />
                    <br />
                    <Heading
                      as="h5"
                      size="lg"
                      pb={5}
                      alignContent={'center'}
                      alignItems={'center'}
                    >
                      KPI Vendas (Empresa/Mundo)
                    </Heading>
                    <TableGrid
                      id="alert-followUp"
                      entity="kpi-sales"
                      data={parseSalesKpiData(
                        data?.kpiVendas?.vendaIndicadorPorMundo
                      )}
                      query={''}
                      headers={kpiSalesHeaderWorld}
                      loading={false}
                      itsSortable={true}
                      height={
                        String(
                          data?.kpiVendas?.vendaIndicadorPorMundo.length * 40
                        ) + 'px'
                      }
                      isPagedBack={false}
                      isPaged={false}
                    />
                  </>
                </Box>
              </>
            )}

            {(data?.kpiRuptura?.aglomeradoCurvaA.length > 0 ||
              data?.kpiRuptura?.aglomeradoCurvaB.length > 0 ||
              data?.kpiRuptura?.aglomeradoCurvaC.length > 0) && (
              <>
                <Box
                  p={6}
                  mx={3}
                  mb={2}
                  bg="white"
                  borderRadius="8px"
                  boxShadow="sm"
                >
                  <Flex
                    alignItems="center"
                    justifyContent="space-between"
                    pb={'21.4px'}
                    mb={6}
                  ></Flex>
                  <>
                    {data?.kpiRuptura?.aglomeradoCurvaA.length > 0 && (
                      <>
                        <Box
                          paddingBottom={3.5}
                          boxShadow="inset 0px 1px 5px 2px #dcdcdc"
                        />
                        <Heading
                          as="h5"
                          size="lg"
                          pb={5}
                          alignContent={'center'}
                          alignItems={'center'}
                        >
                          KPI Ruptura (Empresa/Curva A)
                        </Heading>
                        {data?.kpiRuptura?.graficoAglomeradoCurvaA.zeroDias
                          .length > 0 && (
                          <>
                            <KpiRuptureGraphicExport
                              data={data?.kpiRuptura?.graficoAglomeradoCurvaA}
                            />
                          </>
                        )}
                        <br />
                        <br />

                        <TableGrid
                          id="alert-followUp"
                          entity="kpi-logistic"
                          data={parseRuptureKpiData(
                            data?.kpiRuptura?.aglomeradoCurvaA
                          )}
                          query={''}
                          headers={kpiRuptureHeader}
                          loading={false}
                          itsSortable={true}
                          height={
                            String(
                              data?.kpiRuptura?.aglomeradoCurvaA.length * 50
                            ) + 'px'
                          }
                          isPagedBack={false}
                          isPaged={false}
                        />
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                      </>
                    )}
                  </>

                  <>
                    {data?.kpiRuptura?.aglomeradoCurvaB.length > 0 && (
                      <>
                        <Box
                          paddingBottom={3.5}
                          boxShadow="inset 0px 1px 5px 2px #dcdcdc"
                        />
                        <br />
                        <br />
                        <Heading
                          as="h5"
                          size="lg"
                          pb={5}
                          alignContent={'center'}
                          alignItems={'center'}
                        >
                          KPI Ruptura (Empresa/Curva B)
                        </Heading>
                        {data?.kpiRuptura?.graficoAglomeradoCurvaB.zeroDias
                          .length > 0 && (
                          <>
                            <KpiRuptureGraphicExport
                              data={data?.kpiRuptura?.graficoAglomeradoCurvaB}
                            />
                          </>
                        )}
                        <br></br>
                        <br></br>
                        <TableGrid
                          id="alert-followUp"
                          entity="kpi-logistic"
                          data={parseRuptureKpiData(
                            data?.kpiRuptura?.aglomeradoCurvaB
                          )}
                          query={''}
                          headers={kpiRuptureHeader}
                          loading={false}
                          itsSortable={true}
                          height={
                            String(
                              data?.kpiRuptura?.aglomeradoCurvaB.length * 50
                            ) + 'px'
                          }
                          isPagedBack={false}
                          isPaged={false}
                        />
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                      </>
                    )}
                  </>

                  <>
                    {data?.kpiRuptura?.aglomeradoCurvaC.length > 0 && (
                      <>
                        <Box
                          paddingBottom={3.5}
                          boxShadow="inset 0px 1px 5px 2px #dcdcdc"
                        />
                        <br />
                        <br />
                        <Heading
                          as="h5"
                          size="lg"
                          pb={5}
                          alignContent={'center'}
                          alignItems={'center'}
                        >
                          KPI Ruptura (Empresa/Curva C)
                        </Heading>
                        {data?.kpiRuptura?.graficoAglomeradoCurvaC?.zeroDias
                          .length > 0 && (
                          <>
                            <KpiRuptureGraphicExport
                              data={data?.kpiRuptura?.graficoAglomeradoCurvaC}
                            />
                          </>
                        )}
                        <br />
                        <br />
                        <TableGrid
                          id="alert-followUp"
                          entity="kpi-logistic"
                          data={parseRuptureKpiData(
                            data?.kpiRuptura?.aglomeradoCurvaC
                          )}
                          query={''}
                          headers={kpiRuptureHeader}
                          loading={false}
                          itsSortable={true}
                          height={
                            String(
                              data?.kpiRuptura?.aglomeradoCurvaC.length * 50
                            ) + 'px'
                          }
                          isPagedBack={false}
                          isPaged={false}
                        />
                        <br></br>
                        <br></br>
                      </>
                    )}
                  </>
                </Box>
              </>
            )}

            <Box
              p={6}
              mx={3}
              mb={2}
              bg="white"
              borderRadius="8px"
              boxShadow="sm"
            >
              <Flex
                alignItems="center"
                justifyContent="space-between"
                pb={'21.4px'}
                mb={6}
              ></Flex>

              <>
                <Heading
                  as="h5"
                  size="lg"
                  pb={5}
                  alignContent={'center'}
                  alignItems={'center'}
                >
                  KPI Logistica (Top 10 Maior Desvio)
                </Heading>

                {data?.kpiLogistica?.maioresDesvios && (
                  <>
                    <TableGrid
                      id="alert-followUp"
                      entity="kpi-logistic"
                      data={parseLogisticKpiData(
                        data?.kpiLogistica?.maioresDesvios
                      )}
                      query={''}
                      headers={logisticKpiHeader}
                      loading={false}
                      itsSortable={true}
                      height={
                        String(data?.kpiLogistica?.maioresDesvios.length * 40) +
                        'px'
                      }
                      isPagedBack={false}
                      isPaged={false}
                    />
                  </>
                )}
                <br />
                <br />
                <br />
                <br />
                <Heading
                  as="h5"
                  size="lg"
                  pb={5}
                  alignContent={'center'}
                  alignItems={'center'}
                >
                  KPI Logistica (Top 10 Menor Desvio)
                </Heading>

                {data?.kpiLogistica?.menoresDesvios && (
                  <>
                    <TableGrid
                      id="alert-followUp"
                      entity="kpi-logistic"
                      data={parseLogisticKpiData(
                        data?.kpiLogistica?.menoresDesvios
                      )}
                      query={''}
                      headers={logisticKpiHeader}
                      loading={false}
                      itsSortable={true}
                      height={
                        String(data?.kpiLogistica?.menoresDesvios.length * 40) +
                        'px'
                      }
                      isPagedBack={false}
                      isPaged={false}
                    />
                  </>
                )}
              </>
            </Box>
            <br />
            <br />
            <br />
            <Box maxW="100%" px={3}>
              <Grid
                templateColumns={['', '', '1fr 1fr']}
                gap="16px"
                height="800px"
              >
                {data?.painel?.estoqueGeralPorStatus && (
                  <OverviewTableExport
                    id="alert-followUp"
                    title="Visao Estoque Status (Revenda)  "
                    endpoint="Estoques/Geral/Status"
                    empresasIds={form.empresas}
                    entity="vendas-footer"
                    dataNew={data?.painel?.estoqueGeralPorStatus}
                    headers={overviewGeneralStockTableHeaders}
                    parser={overviewGeneralStockParserWithFooter}
                    parserFooter={overviewGeneralStockParserFooter}
                    isActionFooter={false}
                  />
                )}

                {data?.painel?.estoqueGeralPorStatus && (
                  <Box height="100%" display={['none', 'none', 'block']}>
                    <OverviewTableExport
                      id="alert-followUpr"
                      title="Visao Estoque Encomenda (Top 15)"
                      endpoint="Produtos/StatusEncomenda"
                      entity="encomenda"
                      empresasIds={form.empresas}
                      dataNew={data?.painel?.produtoStatusEncomenda}
                      headers={overviewProductTableHeaders}
                      parser={overviewProductParser}
                      isExpandable
                    />
                  </Box>
                )}
              </Grid>
            </Box>
            <Box maxW="100%" px={3}>
              <Grid
                templateColumns={['', '', '1fr 1fr']}
                gap="16px"
                height="800px"
              >
                {data?.painel?.estoqueGeralPorStatus && (
                  <OverviewTableExport
                    id="alert-followUp"
                    title="Visao Estoque SL/SF (Top 15) "
                    endpoint="Estoques/Geral/Status"
                    empresasIds={form.empresas}
                    entity="vendas"
                    dataNew={data?.painel?.produtoStatusSLSF}
                    headers={overviewProductTableHeaders}
                    parser={overviewProductParser}
                  />
                )}

                {data?.painel?.estoqueGeralPorStatus && (
                  <Box height="100%" display={['none', 'none', 'block']}>
                    <OverviewTableExport
                      id="alert-followUp"
                      title="Visao Estoque s/ Venda 6M (Top 15)"
                      endpoint="Produtos/StatusEncomenda"
                      entity="encomenda"
                      empresasIds={form.empresas}
                      dataNew={data?.painel?.produtoSemVenda}
                      headers={overviewProductTableHeaders}
                      parser={overviewProductParser}
                      isExpandable
                    />
                  </Box>
                )}
              </Grid>
            </Box>
            <Box maxW="100%" px={3}>
              <Grid
                templateColumns={['', '', '1fr 1fr']}
                gap="16px"
                height="800px"
              >
                {/* {data?.painel?.estoqueGeralPorStatus && (
                <OverviewTableExport
                  id="storage-by-status"
                  title="Excesso de Produtos em Estoque"
                  subtitle="TOP 15"
                  endpoint="Estoques/Geral/Status"
                  empresasIds={form.empresas}
                  entity="vendas"
                  dataNew={data?.painel?.estoqueGeralPorStatus}
                  headers={overviewProductTableHeaders}
                  parser={overviewProductParser}
                />
              )} */}

                {data?.painel?.estoqueGeralPorStatus && (
                  <Box height="100%" display={['none', 'none', 'block']}>
                    <OverviewTableExport
                      id="alert-followUp"
                      title="Visao Carteira Fornecedor (Top 15)"
                      endpoint="Produtos/StatusEncomenda"
                      entity="encomenda"
                      empresasIds={form.empresas}
                      dataNew={data?.painel?.estoqueEmCarteiraFornecedor}
                      headers={overviewStockTableHeaders}
                      parser={overviewStockParser}
                      isExpandable
                    />
                  </Box>
                )}
              </Grid>
            </Box>
          </Box>
        </div>
      </PDFExport>
    </>
  )
}

export default Export
